/**
 * 证件号码 / 统一社会信用代码 / 联系方式格式校验（合作作者、转让等场景复用）
 */

export const GLOBAL_PHONE_PATTERN = /^(?:\+861[3-9]\d{9}|(?!\+86)\+\d{1,4}\d{5,15}|1[3-9]\d{9})$/

const MOBILE_PHONE_PATTERN = /^1[3-9]\d{9}$/
const OVERSEAS_PHONE_PATTERN = /^[\d+\-\s()]{6,20}$/

/** 电话：境内为大陆手机号，境外为宽松国际格式（也可直接使用 GLOBAL_PHONE_PATTERN 进行统一校验） */
export function validatePhone(phone, identityType = 'domestic') {
  const v = String(phone || '').trim()
  if (!v) {
    return { valid: false, message: '请输入电话' }
  }
  // 统一支持国际手机号格式
  if (identityType === 'domestic' && v.startsWith('+') && GLOBAL_PHONE_PATTERN.test(v)) {
    return { valid: true, message: '' }
  }
  if (identityType === 'overseas') {
    if (!OVERSEAS_PHONE_PATTERN.test(v)) {
      return { valid: false, message: '请输入正确的电话号码' }
    }
    return { valid: true, message: '' }
  }
  if (!MOBILE_PHONE_PATTERN.test(v)) {
    return { valid: false, message: '请输入正确的手机号码' }
  }
  return { valid: true, message: '' }
}

/** 邮箱（与身份认证页 element-plus email 规则一致） */
export function validateEmail(email) {
  const v = String(email || '').trim()
  if (!v) {
    return { valid: false, message: '请输入邮箱' }
  }
  if (!EMAIL_PATTERN.test(v)) {
    return { valid: false, message: '请输入正确的电子邮件格式' }
  }
  return { valid: true, message: '' }
}

/** 大陆居民身份证 18 位校验码（GB 11643-1999） */
export function validateMainlandIdCardChecksum(id18) {
  const id = String(id18).trim().toUpperCase()
  if (!/^\d{17}[\dX]$/.test(id)) return false
  const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
  const checkCodes = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
  let sum = 0
  for (let i = 0; i < 17; i++) {
    sum += parseInt(id[i], 10) * weights[i]
  }
  return checkCodes[sum % 11] === id[17]
}

/** 大陆居民身份证：15 位或 18 位（含校验位） */
export function validateMainlandIdCard(idNo) {
  const id = String(idNo || '').trim().toUpperCase()
  if (!id) {
    return { valid: false, message: '请输入身份证号码' }
  }
  if (/^\d{15}$/.test(id)) {
    return { valid: true, message: '' }
  }
  if (/^\d{17}[\dX]$/.test(id)) {
    if (!validateMainlandIdCardChecksum(id)) {
      return { valid: false, message: '身份证号码校验位不正确，请核对' }
    }
    return { valid: true, message: '' }
  }
  return { valid: false, message: '请输入正确的身份证号码（15位或18位）' }
}

/**
 * 统一社会信用代码 / 机构证书号
 * 与 EnterpriseIdentityVerification 规则一致
 */
export function validateUnifiedSocialCreditCode(code) {
  const v = String(code || '').trim().toUpperCase()
  if (!v) {
    return { valid: false, message: '请输入统一社会信用代码' }
  }
  const mainlandPattern = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/
  const hkmtPattern = /^[0-9A-Z\-]{8,40}$/
  if (mainlandPattern.test(v) || hkmtPattern.test(v)) {
    return { valid: true, message: '' }
  }
  return { valid: false, message: '请输入正确的统一社会信用代码' }
}

/**
 * 合作作者证件号校验
 * @param {'individual'|'enterprise'} authorType
 * @param {string} authorCard
 */
export function validateCoAuthorCard(authorType, authorCard) {
  if (authorType === 'enterprise') {
    return validateUnifiedSocialCreditCode(authorCard)
  }
  return validateMainlandIdCard(authorCard)
}
